import { debounce, put, select } from 'redux-saga/effects'
import { toggleSummary } from '../../actions/bookingCalendar/calendar/summary'
import { CalendarActions } from '../../reducers/bookingCalendar/actionNames'
import { getSummary } from '../../reducers/bookingCalendar/selectors/summary'

function* displaySummary() {
  const isSummaryOpen = yield select(getSummary)
  if (isSummaryOpen) {
    yield put(toggleSummary(false))
  } else {
    yield put(toggleSummary(true))
  }
}

export default function* () {
  yield debounce(200, CalendarActions.RequestToggleSummary, displaySummary)
}
